import { render, staticRenderFns } from "./project-gallery-destop.vue?vue&type=template&id=356a634f&"
import script from "./project-gallery-destop.vue?vue&type=script&lang=ts&"
export * from "./project-gallery-destop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wamp\\www\\Pentacom\\baumit.com\\vue-project\\references\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('356a634f')) {
      api.createRecord('356a634f', component.options)
    } else {
      api.reload('356a634f', component.options)
    }
    module.hot.accept("./project-gallery-destop.vue?vue&type=template&id=356a634f&", function () {
      api.rerender('356a634f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project-gallery-destop/project-gallery-destop.vue"
export default component.exports